import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { faBookmark } from "@fortawesome/pro-solid-svg-icons/faBookmark";
import { faCircle } from "@fortawesome/pro-solid-svg-icons/faCircle";
import { faFlag } from "@fortawesome/pro-solid-svg-icons/faFlag";
import { faHeart } from "@fortawesome/pro-solid-svg-icons/faHeart";
import { faHexagon } from "@fortawesome/pro-solid-svg-icons/faHexagon";
import { faLocationPin } from "@fortawesome/pro-solid-svg-icons/faLocationPin";
import { faSquare } from "@fortawesome/pro-solid-svg-icons/faSquare";
import { faStar } from "@fortawesome/pro-solid-svg-icons/faStar";
import { faTriangle } from "@fortawesome/pro-solid-svg-icons/faTriangle";

import MarkerShape from "@mapmycustomers/shared/enum/MarkerShape";

const markerShapeToIcon: Partial<Record<MarkerShape, IconProp>> = {
  [MarkerShape.BOOKMARK]: faBookmark,
  [MarkerShape.CIRCLE]: faCircle,
  [MarkerShape.FLAG]: faFlag,
  [MarkerShape.HEART]: faHeart,
  [MarkerShape.HEXAGON]: faHexagon,
  [MarkerShape.PIN]: faLocationPin,
  [MarkerShape.SQUARE]: faSquare,
  [MarkerShape.STAR]: faStar,
  [MarkerShape.TRIANGLE]: faTriangle,
};

const getMarkerShapeIcon = (shape: MarkerShape): IconProp | undefined => markerShapeToIcon[shape];

export default getMarkerShapeIcon;
